








































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import { TransactionResourceType } from '@/modules/transaction/models/transaction-resource.model'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { PanelLayoutRoute } from '@/modules/common/layout/routes/panel-layout.route'

@Component({
  components: { BaseButton }
})
export default class PanelTransactionCard extends Vue {
  constructor(
    private readonly routes: PanelLayoutRoute
  ) {
    super()
  }

  @Prop() transaction!: TransactionResourceType


}
